import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { InventoryResourceRequirement } from "../generic/inventory-resource-requirement/InventoryResourceRequirement";
export var getImprovementCosts = function (balancing, level) {
    var standardCost = balancing.level[level].standard;
    var costs;
    if (standardCost) {
        costs = standardCost.cost;
    }
    return costs;
};
export var ImprovementUpgradeRequirements = function (_a) {
    var item = _a.item;
    var balancing = item.balancing, level = item.level;
    var upgradeCost = getImprovementCosts(balancing, level) || [];
    return (React.createElement("div", { className: IdStyles.ImprovementRequirementsContainerBackground + " improvement__requirements" }, upgradeCost.map(function (cost) { return (React.createElement(InventoryResourceRequirement, { key: cost.resourceId, required: cost.amount, resourceId: cost.resourceId })); })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/improvement/ImprovementUpgradeRequirements.tsx
// module id = 932
// module chunks = 3